export default __webpack_public_path__ + "static/media/Q6_2_resized.077a4169.jpg";